var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"site-page"},[_c('Header'),_c('main',[_c('Banner'),_c('Home')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }